import { TProcedureUpdate } from '../domain/schedule.entities';
import {ScheduleGateway} from '../domain/schedule.gateway';

export class UpdateUseCase {
    constructor(private gate: ScheduleGateway) {}
    async execute(params: TProcedureUpdate): Promise<boolean> {
        return this.gate.update(params);
    }
}